import { LanguageCode } from "./Language.js";
import { VOConfig, VOStepper, VOGate, VOClimate } from "./DataStructure.js";

export class Config {
    public static configTitle: string = "Default";
    public static language: LanguageCode = "de";
    public static stepper: VOStepper = null;
    public static gate: VOGate = null;
    public static climate: VOClimate = null;
    public static impulsToWatt: number = 1;
    public static wattOffset: number = 30;
    public static contentDurationStepper = 10;
    public static dropTolerance = 300;
    public static myclimatePartnerString: string = "dialog-greengate";
    public static maxIdleTimeStepper: number = 15;
    public static maxIdleTimeGate: number = 90;
    public static maxIdleTimeClimate: number = 120;
    public static endScreenDurationStepper: number = 7;
    public static fractionDigitsStepper: number = 2;

    public static init(config: VOConfig, gate: VOGate[], stepper: VOStepper[], climate: VOClimate[]): void {
        if (!config) {
            console.warn("Could not initialize Config-class. Missing config parameter.");
            if (stepper && stepper.length > 0) {
                Config.stepper = stepper[0];
            }
            if (gate && gate.length > 0) {
                Config.gate = gate[0];
            }
            if (climate && climate.length > 0) {
                Config.climate = climate[0];
            }
            return;
        }
        Config.language = config.language || Config.language;
        Config.impulsToWatt = config.impuls_to_watt || Config.impulsToWatt;
        if (stepper)
            Config.stepper = e5.array.match(stepper, "id", config.stepper) || stepper[0];
        if (gate)
            Config.gate = e5.array.match(gate, "id", config.gate) || gate[0];
        if (climate)
            Config.climate = e5.array.match(climate, "id", config.climate) || climate[0];
        Config.wattOffset = config.watt_offset || Config.wattOffset;
        Config.dropTolerance = config.drop_tolerance || Config.dropTolerance;
        Config.myclimatePartnerString = config.myclimate_partner_string || Config.myclimatePartnerString;
        Config.contentDurationStepper = config.content_duration_stepper || Config.contentDurationStepper;
        Config.endScreenDurationStepper = config.end_screen_duration_stepper || Config.endScreenDurationStepper;
        Config.maxIdleTimeStepper = config.max_idle_time_stepper || Config.maxIdleTimeStepper;
        Config.maxIdleTimeGate = config.max_idle_time_gate || Config.maxIdleTimeGate;
        Config.maxIdleTimeClimate = config.max_idle_time_climate || Config.maxIdleTimeClimate;
        Config.fractionDigitsStepper = config.fraction_digits_stepper || Config.fractionDigitsStepper;

    }
}